module.exports = __webpack_public_path__ + "firefox_logo-only.59eb3e62.svg";